import type { ReactNode } from "react";

type HighlightCardProps = {
  children: ReactNode;
  className?: string;
};

// White card that gains a brand border and deeper shadow on hover.
export const HighlightCard = ({
  children,
  className = "",
}: HighlightCardProps) => (
  <article
    className={`group rounded-2xl border border-transparent bg-white p-5 shadow-[0_2px_8px_rgba(26,31,54,0.04)] transition-[border-color,box-shadow] duration-300 hover:border-[#4242CE] hover:shadow-[0_16px_32px_rgba(26,31,54,0.1)] motion-reduce:transition-none ${className}`}
  >
    {children}
  </article>
);
